import React from "react";
import "./NoPostMsg.css"; // Optional: for custom styling

interface NoPostMsgProps {
  message: string;
  className?: string;
  children?: React.ReactNode;
}

const NoPostMsg: React.FC<NoPostMsgProps> = ({ message, className = "", children }) => (
  <div className={`outer-container-subcomponents no-content empty-state-message mb-mt-2 ${className}`}>
    <p>{message}</p>
    {children}
  </div>
);

export default NoPostMsg;
